<div class="section-endpoints" *ngIf="busy || groups.length; else noData">
  <div class="label" *ngIf="label">{{ label }}</div>
  <ng-container *ngIf="!busy; else busySpinner">
    <ng-container *ngFor="let group of groups | endpointGroupsSearch: search; trackBy: trackByFn">
      <div class="item">
        <div class="arrow" [@toggleArrow]="isExpanded(group.id)" (click)="onToggleState(group)">
          <i nz-icon nzType="ng-zorro:arrowDown" class="arrow-icon"></i>
        </div>
        <label
          class="title"
          nz-checkbox
          [(ngModel)]="group.checked"
          (ngModelChange)="onCheckedChange($event, group)"
        >
          {{ group.name }}
        </label>
      </div>
      <ng-container *ngIf="isExpanded(group.id) === 'visible'">
        <div class="item endpoint" *ngFor="let endpoint of group.endpoints | groupEndpointsSearch: search">
          {{ endpoint.name }}
        </div>
        <div class="item endpoint empty" *ngIf="!group.endpoints.length">No endpoints in this group</div>
      </ng-container>
    </ng-container>
  </ng-container>
  <ng-template #busySpinner>
    <img style="margin: 0 37%" src="/assets/img/spinner.gif" />
  </ng-template>
</div>

<ng-template #noData>
  <app-groups-placeholder></app-groups-placeholder>
</ng-template>
